/* eslint no-unused-vars: 1 */

(function() {
    'use strict';
    angular.module('portingstatus').service('orderStatusInportService', [ '$http', '$injector', function($http, $injector) {

        var config = $injector.get('config');

        function orderStatusByOrderId(orderId, firstname, lastname) {
            var data = {
                order_id: orderId, // eslint-disable-line camelcase
                firstname: firstname,
                lastname: lastname,
            };
            return putOrderStatus(data);
        };

        function orderStatusByMSISDN(msisdn, ban) {
            var data = {
                msisdn: msisdn,
                ban: ban
            };
            return putOrderStatus(data);
        };

        function putOrderStatus(data) {
            return $http({
                method: 'PUT',
                data: data,
                url: config.apiURLs.ORDERSTATUSINPORT
            });
        };

        return {
            orderStatusByOrderId: orderStatusByOrderId,
            orderStatusByMSISDN: orderStatusByMSISDN
        };
    }
    ]);

})();
